<template>
  <div class="fou-dashboard-articles" data-qa-id="blur-articles-videos">
    <!-- top highlighted cms content -->
    <div class="fou-dashboard-articles__featured">
      <!-- content -->
      <div class="fou-dashboard-articles__featured__block">
        <!-- iteration -->
        <div
          v-for="article in CMS.primary.articles"
          :key="article.title"
          class="fou-dashboard-articles__featured__block__content"
          :style="bgImage(article.img)"
        >
          <div class="fou-dashboard-articles__featured__block__content__info backdrop--blur">
            <div class="fou-dashboard-articles-featured-content is-blur--medium">
              <!-- label -->
              <p class="fou-dashboard-articles__featured__block__content__info__subtitle">
                {{ article.subTitle }}
              </p>
              <h4
                data-qa-id="variable-media-image-title"
                class="fou-dashboard-articles__featured__block__content__info__title"
              >
                <!-- title -->
                <span>
                  {{ article.title }}
                </span>
              </h4>
              <!-- big content buttom desc -->
              <div class="artile-btn-wrap">
                <a class="article-read-more-btn"> {{ CMS.readmore }} </a>
                <p class="fou-dashboard-articles__featured__block__content__info__desc">{{ article.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- buttom cms content list -->
    <div class="fou-dashboard-articles__content">
      <!-- title -->
      <h2 data-qa-id="highlight-media-label-text" class="fou-dashboard-articles__content__title">
        {{ CMS.secondary.mainTitle }}
      </h2>
      <!-- list iteration -->
      <div
        v-for="article in CMS.secondary.articles"
        :key="article.title"
        class="fou-dashboard-articles__content__block"
      >
        <div class="fou-articles-content">
          <!-- image -->
          <div class="fou-articles-content__image" :style="bgImage(article.img)" >
            <div class="backdrop--blur fou-overlay" />
          </div>
          <!-- description -->
          <div class="fou-articles-content__text is-blur is-blur--less">
            <!-- text -->
            <div class="fou-articles-content__text__para">
              <p class="fou-articles-content__text__para__subtitle">
                {{ article.subTitle }}
              </p>
              <h4 class="fou-articles-content__text__para__title">
                {{ article.title }}
              </h4>
              <p class="fou-articles-content__text__para__desc">
                {{ article.description }}
              </p>
            </div>
            <!-- readmore -->
            <div class="fou-articles-content__text__cta">
              <a class="fou-articles-content__text__cta__btn">
                {{ CMS.readmore }}
                <readmore-icon class="cta-icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./script.js"></script>
